import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Form } from 'semantic-ui-react'

class FormInputDropdown extends Component {
  static propTypes = {
    error: PropTypes.bool,
    hasNoLabel: PropTypes.bool,
    multiple: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    pending: PropTypes.bool,
    search: PropTypes.bool,
    selection: PropTypes.bool,
    text: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
  }

  static defaultProps = {
    hasNoLabel: false,
    multiple: true,
    search: true,
    selection: true,
  }

  render() {
    const { error, hasNoLabel, multiple, name, onChange, options, pending, search, selection, text, value } = this.props

    return (
      <Form.Field>
        {!hasNoLabel && <label>{text}</label>}

        <Form.Dropdown
          error={error}
          loading={pending}
          multiple={multiple}
          name={name}
          onChange={onChange}
          options={options}
          placeholder={text}
          search={search}
          selection={selection}
          value={value}
          fluid
        />
      </Form.Field>
    )
  }
}

export default FormInputDropdown
